<script>
    import { fly } from "svelte/transition";
    import { ResultPage } from '../index'
</script>

<div class="example" transition:fly={{ x: 200 }}>
    <h4 class="example-title">成功</h4>
    <div class="example-body" style:background={"white"}>
        <ResultPage desc="内容详情可折行，建议不超过两行建议不超过两行建议不超过两行" />
    </div>
    <h4 class="example-title">失败</h4>
    <div class="example-body" style:background={"white"}>
        <ResultPage
            status="warn"
            desc="内容详情可折行，建议不超过两行建议不超过两行建议不超过两行"
        />
    </div>
    <h4 class="example-title">处理中</h4>
    <div class="example-body" style:background={"white"}>
        <ResultPage
            status="progress"
            desc="内容详情可折行，建议不超过两行建议不超过两行建议不超过两行"
        />
    </div>
</div>

<style lang="less">
    @import "./example.less";
</style>
